<template>
	<FormGroup :state="error === null" :invalid-feedback="showError ? error : undefined" :add-invalid-class="false" feedback-beneath>
		<b-row>
			<b-col md="4">
				<FormGroup :state="countryCodeValid" no-margin>
					<b-form-select v-model="countryCode" :options="countryCodes" @input="emitChangeEvent"/>
				</FormGroup>
			</b-col>
			<b-col md="8">
				<FormGroup :state="numberValid" no-margin class="mt-2 mt-md-0">
					<b-input v-model="number" placeholder="Mobil-Nummer" @input="emitChangeEvent"/>
				</FormGroup>
			</b-col>
		</b-row>
	</FormGroup>
</template>

<script>
import _ from "lodash";
import {isEmptyOrNull, removeWhitespaces} from "@/helper/String";
import {isNumberValid} from "@/helper/form/Phone";
import FormGroup from "@/vue/common/form/Group";
import {isDefined} from "@/helper/Value";

const PRIO_COUNTRY_CODES = [41, 49, 43]; // reverse order of prio for logic beneath

export default {

	components: {
		FormGroup,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
		showMissingError: {
			type: Boolean,
			required: false,
			default: true
		}
	},

	data ()
	{
		let countryCodes = _.map(this.meta.countryCodes, item =>
		{
			return {
				value: item.countryCode,
				text: item.country + ' (+' + item.countryCode + ')',
			}
		});

		countryCodes.sort((a, b) =>
		{
			const prioIndexA = _.findIndex(PRIO_COUNTRY_CODES, code => code === a.value);
			const prioIndexB = _.findIndex(PRIO_COUNTRY_CODES, code => code === b.value);

			if (prioIndexA === prioIndexB)
			{
				return a.text.localeCompare(b.text);
			}

			return prioIndexA > prioIndexB ? -1 : 1;
		});

		countryCodes.unshift({
			value: null,
			text: '--- Staatenvorwahl ---',
		})

		return {
			countryCode: this.value?.countryCode ? this.value.countryCode : 43,
			number: this.value?.number ? this.value.number : '',
			countryCodes: Object.freeze(countryCodes),
		};
	},

	computed: {
		countryCodeValid ()
		{
			return isDefined(this.countryCode);
		},
		numberValid ()
		{
			return !isDefined(this.numberError);
		},
		numberMissing ()
		{
			return isEmptyOrNull(this.number);
		},
		showError ()
		{
			return this.error && (this.showMissingError || !this.numberMissing);
		},
		numberError ()
		{
			if (isEmptyOrNull(this.number))
			{
				return 'Nummer fehlt';
			}

			if (!isEmptyOrNull(this.number) && !isNumberValid(this.number))
			{
				return 'Nummer ungültig: nur Ziffern und Leerzeichen erlaubt';
			}

			return null;
		},
		error ()
		{
			let parts = [];

			if (!this.countryCodeValid)
			{
				parts.push('Staatenvorwahl ungültig');
			}

			if (!this.numberValid)
			{
				parts.push(this.numberError);
			}

			return parts.length > 0
				? parts.join(', ')
				: null;
		}
	},

	methods: {
		emitChangeEvent ()
		{
			if (this.error)
			{
				this.$emit('input', null);

				return this;
			}

			this.$emit('input', {
				countryCode: this.countryCode,
				number: _.trimStart(
					removeWhitespaces(this.number),
					'0'
				),
			});
		},
	}
}
</script>
